import './Auth.style.scss';
import './Login.style.css';
import './Register.scss';
import './RegisterMobile.scss';

import { ArrowForward } from '@mui/icons-material';
import { Button} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import ReactCodeInput from 'react-code-input';
import { useTranslation } from 'react-i18next';
// import "./Register.style.scss"
import { useLocation,useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import axios from '../../Api/axios';
import {DELAY, ROLES } from '../../config';
import Logo from '../../data/Logo';
import { DrawLine, OneColoredLine, OneLine, RegisterSvgDraw } from '../../data/SVGs';
import useAuthSetState from '../../hooks/useAuthSetState';
import useWindowSize from '../../hooks/useWindowSize';
import { PropsReactCodeInput, PropsReactCodeInputMobile } from '../../Styles/componentStyles';
import { buttonStyles, buttonStylesBlue } from '../docsAdministrative/JsObjectStyles';
import NavbarHome from '../shared/Navbar/NavbarHome';

function RegisterStepTwo() {
    let navigate = useNavigate();
    const location = useLocation(); // to get current route
    // get where they came from
    const from = location.state?.from?.pathname || '/';
    const {setAuthState} = useAuthSetState();
    const [confirmationCode, setConfirmationCode] = useState();
    const [count, setCount] = useState(60);
    const [disabled, setDisabled] = useState(true);
    const {device}=useWindowSize();
    const [width, setWidth] = useState(0);
    const { i18n } = useTranslation();
    const divRef = useRef(null);
    useEffect(() => {
        let intervalId = null;
        if (count > 0) {
            intervalId = setInterval(() => {
                console.log(count);
                setCount(count - 1);
            }, 1000);
        } else {
            setDisabled(false);
        }
        return () => {
            clearInterval(intervalId);
        };
    }, [count]);
    const handlePinChange = pinCode => {
        console.log(pinCode);
        setConfirmationCode(pinCode);
    };

    useEffect(() => {
        const updateWidth = () => {
            if (divRef.current) {
                const rect = divRef.current.getBoundingClientRect();
                setWidth(rect.width);
            }
        };

        // Call the function initially to set the initial width
        updateWidth();

        // Attach the event listener to update the width when the window is resized
        window.addEventListener('resize', updateWidth);

        // Cleanup the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', updateWidth);
        };
    }, [divRef]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    const demandNewConfirmationCode = async () => {
        const accessToken = location.state?.savedResponse?.accessToken;
        const config = {
            headers: { Authorization: `Bearer ${accessToken}` }
        };
        axios.post('auth/demandNewConfirmationCode', {}, config)
            .then(function (response) {
                console.log(response?.data);
                setCount(60);
                setDisabled(true);}
            );
    };

    const submitCode = async e => {
        const accessToken = location.state?.savedResponse?.accessToken;
        e.preventDefault();
        console.log('log', location.state?.savedResponse);
        const config = {
            headers: { Authorization: `Bearer ${accessToken}` }
        };
        axios.post('auth/activateAccount', { confirmationCode }, config)
            .then(function (response) {
                console.log(response?.data);
                setAuthState({responseData: {
                    accessToken,
                    user: response.data?.user
                }, });
                // ! if the user was coming from the HOME
                if (from === '/') {
                    setTimeout(() => {
                        navigate('/welcomeCompletion',{ state: { isFromRegister: true } });
                    }, DELAY);
                }
                // ! continue to what he was searching for
                navigate(from, { replace: true });
            })
            .catch(function (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error.response.data?.error,
                });
                if (error.response.status === 401) {
                    console.log(error.response.data?.error);
                    //redirect to login
                }
            });
    };

    return (
        <div className='HomePageInscription'>
            {device!='desktop' &&
            <NavbarHome />
            }
            {device=='desktop' &&
            <div className='FirstRectangle'>
                <div className='LogoTitle'>
                    <div className='frame0RegisterStepOne'>
                        <Logo
                            width='198px'
                            height='54px'
                        />
                    </div>
                    <div className='frame1RegisterStepOne'>
                        <h3 className='TitleInscrire'> {i18n.t('Joindre notre communauté des ')}
                            {location.state?.savedResponse?.user?.role === ROLES.Client &&
                                <h3
                                    style={{
                                        fontFamily: 'Lato',
                                        fontStyle: 'normal',
                                        fontWeight: '700',
                                        fontSize: '48px',
                                        display: 'inline',
                                        lineHeight: '56px',
                                        color: 'rgba(92, 200, 137, 1)'
                                    }}
                                > {i18n.t('Clients')}
                                </h3>
                            }
                            {location.state?.savedResponse?.user?.role === ROLES.Expert &&
                                <h3
                                    style={{
                                        fontFamily: 'Lato',
                                        fontStyle: 'normal',
                                        fontWeight: '700',
                                        fontSize: '48px',
                                        display: 'inline',
                                        lineHeight: '56px',
                                        color: 'rgba(92, 200, 137, 1)'
                                    }}
                                > {i18n.t('Experts')}
                                </h3>
                            }
                            {location.state?.savedResponse?.user?.role === ROLES.Esn &&
                                <h3
                                    style={{
                                        fontFamily: 'Lato',
                                        fontStyle: 'normal',
                                        fontWeight: '700',
                                        fontSize: '48px',
                                        display: 'inline',
                                        lineHeight: '56px',
                                        color: 'rgba(92, 200, 137, 1)'
                                    }}
                                > {i18n.t('ESN')}
                                </h3>
                            }
                        </h3>

                    </div>

                </div>
                <div className='DrawIconeStyle'>
                    <RegisterSvgDraw />
                </div>
            </div>
            }

            <div  className='rect123434'>
                {device=='desktop'&&
                <div className='BtnSinscrire'>
                    <p style={{margin:0}}>{i18n.t('Déjà enregistré?')}  &nbsp; &nbsp;</p>
                    <Button
                        variant="outlined"
                        style={{
                            ...buttonStyles(),
                            ...{height:'36px'}
                        }}
                        onClick={() => navigate('/login')}
                        startIcon={<ArrowForward />}
                    >
                        {i18n.t('Se connecter')}
                    </Button>
                </div>
                }
                <div className='GrandBox'>
                    <div
                        className='Etape'
                        style={{paddingBottom:'110px'}}
                    >
                        <div className='E12'>
                            <p className='etape12'>{i18n.t('Etape 2/2')}</p>
                            <div style={{display:'flex',flexDirection:'row'}}>
                                <OneLine /> <OneColoredLine />
                            </div>
                            {/*<UnSurDeux />*/}
                            <h1 className='creercompte2'>{i18n.t('Créer un compte')}</h1>
                        </div>
                    </div>
                    <div className='Element2Register'>
                        <h4 className='verifieremail'>{i18n.t('Vérifier l\'adresse e-mail')}</h4>
                        <p className='codeverif'>{i18n.t('Un message avec un code de vérification a été envoyé à votre adresse e-mail. Veuillez entrer le code pour continuer.')}</p>

                    </div>

                    <div className='Boxcodeverif'>
                        <div className='Subbox1'>
                            {device=='desktop' ?
                                <ReactCodeInput
                                    id="pinCode"
                                    type='number'
                                    fields={4}
                                    value={confirmationCode}
                                    onChange={handlePinChange}
                                    className='reactInput'
                                    {...PropsReactCodeInput}
                                />
                                :
                                <ReactCodeInput
                                    id="pinCode"
                                    type='number'
                                    fields={4}
                                    value={confirmationCode}
                                    onChange={handlePinChange}
                                    className='reactInput'
                                    {...PropsReactCodeInputMobile}
                                />
                            }
                        </div>
                        <div className='BtnBox'>
                            <Button
                                variant='text'
                                onClick={demandNewConfirmationCode}
                                style={{
                                    ...buttonStyles(),
                                }}
                                disabled={disabled}
                            >
                                {count > 0 ? `${i18n.t('Demander un nouveau code ')}(${count}s)` : i18n.t('Renvoyer le code')}
                            </Button>
                            <Button
                                variant='text'
                                style={{
                                    ...buttonStyles(),
                                }}
                                onClick={() => { navigate('/register'); }}
                            >
                                {i18n.t('Modifier l\'Email')}
                            </Button>
                        </div>

                        <div className='BtnBox2'>
                            <Button
                                variant="outlined"
                                onClick={() => { navigate('/register');}}
                                style={{
                                    ...buttonStyles(),...{width: '40%'}
                                }}
                            >{i18n.t('Précédent')}</Button>
                            <Button
                                variant="contained"
                                type="submit"
                                onClick={submitCode}
                                style={{
                                    ...buttonStylesBlue(false),
                                    ...{width: '60%'}
                                }}
                            >
                                {i18n.t('Vérifier')}
                            </Button>
                        </div>
                    </div>
                    {device!='desktop' &&
                    <>
                        <div className='rect127434'>
                            <div
                                style={{width:'47%'}}
                                ref={divRef}
                            >
                                <DrawLine width={width}/>
                            </div>
                            <span style={{width:'6%',textAlign:'center'}}>Ou</span>
                            <div style={{width:'47%'}}>
                                <DrawLine width={width}/>
                            </div>
                        </div>
                        <div className='BtnSinscrire'>
                            <p style={{margin:0}}>{i18n.t('Déjà enregistré?')}  &nbsp; &nbsp;</p>
                            <Button
                                variant="outlined"
                                style={{
                                    ...buttonStyles(),
                                    ...{height:'36px'}
                                }}
                                onClick={() => navigate('/login')}
                                startIcon={<ArrowForward />}
                            >
                                {i18n.t('Se connecter')}
                            </Button>
                        </div>
                    </>
                    }
                </div>
            </div>
        </div>
    );
}

export default RegisterStepTwo;